import React from "react";
import FullCalendar from "../components/containers/FullCalendar";
import Paper from "@material-ui/core/Paper";
import { Slogan } from "domains/Task/components/Slogan/Slogan";
import { useCalendarStyle } from "../style";

export function GiftCalendar() {
  const styles = useCalendarStyle();

  return (
    <Paper className={styles.root}>
      <Slogan showButton={false} />
      <FullCalendar />
    </Paper>
  ); 
}
  

export default GiftCalendar;
